import React, { useState } from "react";

import ChordsButton from "./ChordsButton";
import { Wrapper } from "./styles";
import { IProps } from "./interfaces";
import { hasChords4 } from "./utils";

const Chords3Ladder = (props: IProps) => {
    const [open, setOpen] = useState<string | null>(null);
    const handleOpen = (type: string | null) => {
        if (type === open) {
            setOpen(null);
            return;
        }
        setOpen(type);
    };
    const handleInput = (input: string) => {
        props.handleInput(input);
        handleOpen(null);
    };
    const { hasDominant7, hasDiminished7 } = hasChords4(props.score);
    return (
        <Wrapper>
            <ChordsButton open={open} handleOpen={handleOpen} handleInput={handleInput} type="D" />
            <ChordsButton open={open} handleOpen={handleOpen} handleInput={handleInput} type="m" />
            <ChordsButton open={open} handleOpen={handleOpen} handleInput={handleInput} type="s" />
            <ChordsButton open={open} handleOpen={handleOpen} handleInput={handleInput} type="B" />
            {hasDominant7 && (
                <ChordsButton open={open} handleOpen={handleOpen} handleInput={handleInput} type="D7" />
            )}
            {hasDiminished7 && (
                <ChordsButton open={open} handleOpen={handleOpen} handleInput={handleInput} type="s7" />
            )}
        </Wrapper>
    );
}

export default Chords3Ladder;
